'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var PropTypes = require('prop-types');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefault(React);
var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var FooterLegal = function FooterLegal(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/React__default.default.createElement("div", {
    id: "lanl-ft-legal-col"
  }, /*#__PURE__*/React__default.default.createElement("ul", {
    className: "list-unstyled ft-legal-list"
  }, data.map(function (_ref2) {
    var label = _ref2.label,
      link = _ref2.link;
    return /*#__PURE__*/React__default.default.createElement("li", {
      key: label
    }, /*#__PURE__*/React__default.default.createElement("a", {
      className: "legal-links",
      href: link
    }, label));
  })));
};
FooterLegal.propTypes = {
  data: PropTypes__default.default.array.isRequired
};

exports.FooterLegal = FooterLegal;
exports.default = FooterLegal;
//# sourceMappingURL=FooterLegal.js.map
